module.exports = __webpack_public_path__ + "static/media/cxv.26250e91.png";